import { put } from 'redux-saga/effects';
import { Types } from './actions';

export default function* execute(action: any): any {
  try {
    const { academicDateId } = action;
    yield put({
      type: Types.SELECT_ACADEMIC_DATE_SUCCESS,
      data: academicDateId
    });
  } catch (error) {
    yield put({
      type: Types.SELECT_ACADEMIC_DATE_CLEAR,
      error: 'Ocurrió un error.'
    });
    throw error;
  }
}
